import {
  // Avatar, Button,
  Card, CardContent, Typography, Stack, Chip, Box, Grid, CardMedia, styled,
  Button,
  // CardActions
} from '@mui/material';
import Link from 'next/link';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
// import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
// import { readingTime } from '../../utils/helpers';
import { getRandomStr } from '../../../helpers';
import { useRouter } from 'next/router';
import PricingAdBanner from '../../PricingAdBanner';
import { useState } from 'react';

// const LightTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.primary.main,
//     // color: 'rgba(0, 0, 0, 0.87)',
//     color: '#fff',
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//   },
// }));

const StyledCard = styled(Card)`
  cursor: pointer;
  overflow: hidden;
  img { transition: transform 300ms ease-in-out; }
  .view-more-btn { transition: transform 100ms ease-in-out; }
  &:hover img { transform: scale(1.02); }
  &:hover .view-more-btn { transform: scale(1.04); }`;

export default function TopIdea({ post, index, pageLoading }) {
  const router = useRouter();
  const [more, setMore] = useState(false);

  const convertTime12to24 = time12h => {
    const [time, modifier] = time12h?.split(' ');
    let [hours, minutes, seconds] = time ? time.split(':') : null;
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
  };

  const getDate = (date) => {
    let d = new Date(date);
    let n = d.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
    let t = d.toLocaleTimeString('en-US', { timeZone: "America/New_York" })
    let replase = n.replace(new RegExp(',', 'g'), ' ')
    return `${replase} • ${convertTime12to24(t)}`
  }

  const isDateWithinLastFiveDays = (dateString) => {
    const inputDate = new Date(dateString);
    const currentDate = new Date();

    // Calculate the difference in time
    const timeDifference = currentDate - inputDate;

    // Convert time difference from milliseconds to days
    const differenceInDays = timeDifference / (1000 * 60 * 60 * 24);

    return differenceInDays <= 5;
  }


  return (
    <>
      {/* <Stack
        direction={{ xs: 'column', sm: 'column', md: 'row' }}
        spacing={{ xs: 1, sm: 2, md: 3 }}
      > */}
      <Grid size={{ md: 12, xs: 12, sm: 12 }}>
        {/*{posts && posts.length > 0 ? posts.slice(0, dataConstants.TOP_IDEA).map((post, index) => {
          return ( */}
        <StyledCard key={index} className={post?.frontmatter?.tags?.find(d => d === 'premium') ? 'premium-blog' : 'blog'}
          onClick={() => router.push(`/stock-ideas/${post.slug}`)}
          sx={{
            // maxWidth: 650,
            height: '100%',
            // '&:hover': { background: '#fff', boxShadow: '0 3px 5px rgba(132,135,154,.2), 0 1px 1px rgba(132,135,154,.2)' },
            border: '1px solid #b3cbd936',
            cursor: 'pointer', p: '12pxx', borderRadius: '8px', boxShadow: 0, mx: { md: 2, sm: 1, xs: 1 },
            // display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
            // bgcolor: (post?.frontmatter?.tags?.find(d => d === 'premium') || (index === 0 || index === 1)) ? '#f8f9fa' : 'transparent'
            display: 'flex', flexDirection: { md: 'row', sm: 'column', xs: 'column' }, overflow: 'hidden',
          }}
        >
          {post?.frontmatter?.cover_image &&
            <CardMedia
              component="img"
              // width="194"
              // height="auto"
              image={post?.frontmatter?.cover_image}
              alt={post?.frontmatter?.title}
              sx={{
                minHeight: { md: '100%', sm: '232px', xs: '232px' }, maxHeight: { md: '100%', sm: '232px', xs: '232px' },
                flexBasis: '573px', flexShrink: 1, zIndex: 0, objectFit: 'cover', cursor: 'pointer', minWidth: "200px"
              }}
            />}
          <Box component="div"
            sx={{
              m: { xs: 0, md: '15px', sm: '15px' }, flexBasis: 0, flexShrink: 0, flexGrow: 1, display: 'flex',
              flexDirection: 'column', justifyContent: 'space-between', zIndex: 1, background: '#fff',
            }}>
            <CardContent sx={{}}>
              {/* <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                {post?.frontmatter?.tags?.map(d =>
                  d && d === 'premium' ?
                    <Chip key={getRandomStr(3)} label={d} size="small" sx={{ background: 'linear-gradient(to right, #2DA1EE, #174ea6)', color: '#fff', textTransform: 'capitalize' }} /> :
                    <Chip key={getRandomStr(3)} label={d.replace(/-/g, " ")} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', textTransform: 'capitalize' }} />)}
                {(index == 0 || index == 1) && !post?.frontmatter?.tags?.find(d => d === 'latest') && <Chip label={`Latest`} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', }} />}
              </Stack> */}
              <Typography variant="h6" component="div"
                sx={{
                  fontWeight: 600, fontSize: '24px', '& a': { color: '#1d1d1f', textDecoration: 'none' },
                  '& a:hover': { color: '#174ea6', textDecoration: 'underline' }, lineHeight: 1.2, //mb: 1.5
                }}
              >
                <Link href={`/stock-ideas/${post.slug}`}>
                  {post?.frontmatter?.title}
                </Link>
              </Typography>
              <Box component="div" sx={{ mx: 0, my: 1, flexGrow: 1, display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
                {/* <CardActions sx={{ px: { xs: 2, sm: 3, md: 3 }, pb: 3 }}> */}
                <Typography variant="caption" sx={{ fontSize: '.875rem', fontWeight: 500, mr: 2, }} color="#444"> {/* #6e6e73 */}
                  Last Updated: {getDate(post?.frontmatter?.date)}
                </Typography>
                {isDateWithinLastFiveDays(post?.frontmatter?.date) && post?.frontmatter?.latest ?
                  <Chip label={`Latest`} size="small" sx={{ background: '#E7EBF0', color: '#174ea6', border: 1, borderColor: '#3E50602c' }} /> : null}
                {/* <Button href={`/stock-ideas/${post.slug}`} size="small" endIcon={<KeyboardArrowRightRoundedIcon fontSize="small" />} sx={{ textTransform: 'none', ml: 'auto', fontSize: '.8rem', fontWeight: 600 }}>Read more</Button> */}
                {/* </CardActions> */}
              </Box>
              <Typography variant="body1"
                sx={{ fontSize: '.97rem', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis' }}
                color="#444" //  color="text.secondary"
              >
                {post?.frontmatter?.description}
              </Typography>
              <Box component="div" sx={{ position: "relative" }}>
                <Typography
                  variant="body1"
                  gutterBottom
                  component="div"
                  // className={more ? '' : `postContent`}
                  sx={{
                    mb: 1, fontWeight: 500, color: 'text.description', fontSize: '.95rem', '& ul': { paddingInlineStart: "17px", mt: 1 }
                    // display: '-webkit-box', WebkitLineClamp: more ? 0 : 8, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis'
                  }}
                  dangerouslySetInnerHTML={{
                    __html: `
                      ${post?.frontmatter?.new ?
                        `<div style="margin: 0;font-family: &quot;Roboto&quot;, &quot;Helvetica&quot;, &quot;Arial&quot;, sans-serif;font-weight: 400;font-size: 1rem;
                        line-height: 1.5;letter-spacing: 0.00938em;margin-bottom: 0.35em;color: #174ea6;margin-right: 16px;margin-top: 16px;white-space: nowrap;"
                        >
                          What's New:
                        </div>
                        ${post?.frontmatter?.new}` : ``}
                       ${post?.frontmatter?.performance ?
                        `<div style="margin: 0;font-family: &quot;Roboto&quot;, &quot;Helvetica&quot;, &quot;Arial&quot;, sans-serif;font-weight: 400;font-size: 1rem;
                        line-height: 1.5;letter-spacing: 0.00938em;margin-bottom: 0.35em;color: #174ea6;margin-right: 16px;margin-top: 16px;white-space: nowrap;"
                        >
                          Performance so Far:
                        </div>
                        ${post?.frontmatter?.performance}` : ``}`
                  }}
                />
                {/* <Box sx={{ zIndex: 9, width: '100%', textAlign: 'center', position: 'absolute', bottom: -27 }} >
                  <Button className="view-more-btn" variant="text" fontSize="small"
                    onClick={() => setMore(!more)}
                    sx={{ textTransform: 'none', color: '#3E5060', fontSize: '.875rem', '&:hover': { color: '#174ea6', } }} startIcon={more ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}>
                    {more ? `View Less` : `View More`}
                  </Button>
                </Box> */}
              </Box>
            </CardContent>
            {/* <Stack direction="row" spacing={1} sx={{ m: 2 }}>
              {post?.frontmatter?.tags?.map(d =>
                d && d === 'premium' ?
                  <Chip key={getRandomStr(3)} label={d} size="small" sx={{ background: 'linear-gradient(to right, #2DA1EE, #174ea6)', color: '#fff', textTransform: 'capitalize' }} /> :
                  <Chip key={getRandomStr(3)} label={d.replace(/-/g, " ")} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', textTransform: 'capitalize' }} />)}
              {(index == 0 || index == 1) && !post?.frontmatter?.tags?.find(d => d === 'latest') && <Chip label={`Latest`} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', }} />}
            </Stack> */}
          </Box>
        </StyledCard>
        {/* )})  null}*/}
      </Grid>
      {/* <Stack
          direction='column'
          justifyContent="space-between"
          spacing={{ xs: 1, sm: 2, md: 2 }}
        >
          {posts && posts.length > 0 ? posts.slice(1, 3).map((post, index) => {
            return (
              <Card key={getRandomStr(3)} variant="outlined" sx={{ border: '1px solid #E7EBF0', borderRadius: '8px', width: '100%', display: 'flex', '&:hover': { boxShadow: 5 } }}>
                <Box component="div">
                  <CardContent sx={{ pb: 1 }}>
                    <Stack direction="row" spacing={1}>
                      <Chip label={post?.slug.replace(/-/g, " ")} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', textTransform: 'capitalize' }} />
                      <Chip label="8 min read" size="small" sx={{ background: 'transparent', color: '#3E5060' }} />
                    </Stack>
                    <Typography variant="h6" component="div" sx={{ mt: 1, fontWeight: 600, fontSize: '1rem', '& a': { color: '#000', textDecoration: 'none' }, '& a:hover': { color: 'text.link', textDecoration: 'underline' } }}>
                      <Link href={`/blogs/${post.slug}`}>
                        {post?.frontmatter?.title}
                      </Link>
                    </Typography>
                    <LightTooltip followCursor title={post?.frontmatter?.description} disableInteractive placement="bottom-start">
                      <Typography variant="inherit" noWrap sx={{ mb: 1.5, maxWidth: '25rem', fontSize: '.9rem' }} color="text.secondary">
                        {post?.frontmatter?.description}
                      </Typography>
                    </LightTooltip>
                  </CardContent>
                  <CardActions>
                    <Avatar
                      alt={post?.frontmatter?.author}
                      src="/"
                      sx={{ border: '3px solid', borderColor: '#E7EBF0', backgroundColor: '#174c86', color: '#fff', fontWeight: 500, mx: .5 }}
                    />
                    <Box component="div" sx={{}}>
                      <Typography variant="body2" component="div" sx={{ fontSize: '0.87rem', fontWeight: 600 }} color="text.color.white">
                        {post?.frontmatter?.author}
                      </Typography>
                      <LightTooltip followCursor title={`${post?.frontmatter?.date}`} disableInteractive placement="bottom-start">
                        <Typography variant="caption" sx={{ fontSize: '0.8rem', }} color="#3E5060">
                          {timeSince(new Date(post?.frontmatter?.date))} ago
                        </Typography>
                      </LightTooltip>
                    </Box>
                    <Button href={`/blogs/${post?.slug}`} size="small" endIcon={<KeyboardArrowRightRoundedIcon fontSize="small" />} sx={{ textTransform: 'none', ml: 'auto', fontSize: '.8rem', fontWeight: 600 }}>Read more</Button>
                  </CardActions>
                </Box>
              </Card>)
          })
            : null}
        </Stack> */}
      {/* </Stack> */}
      {pageLoading ? null :
        <PricingAdBanner
          bannerType={"inapp-ad-stock-ideas"}
          adTitle={"Read More From Grufity – and All Premium Posts From Us"}
          adDesc={"Gain full access to unlimited stock ideas, stock screener, fair value, and more by becoming a member today."} // for only $1.99."}
        />}
    </>
  )
}
